import { FC, useMemo } from "react";

const activityLabels: Record<string, string> = {
  set_quiz_basic_info: 'Setting quiz info',
  create_questions: 'Creating questions',
  update_questions: 'Updating questions',
  delete_questions: 'Deleting questions',
  update_quiz_theme: 'Updating theme',
  set_landing_page: 'Editing landing page',
  generate_image: 'Generating images',
  set_call_to_action: 'Editing CTA',
  set_waiver_page: 'Editing waiver page',
  set_countdown_page: 'Editing countdown page',
  configure_question_settings: 'Configuring question settings',
  web_search: 'Searching the web',
};

type Props = {
  activities?: string[];
};

const ActivityStatus:FC<Props> = ({ activities = [] }) => {
  const labels = useMemo(() => {
    return activities.map((a) => activityLabels[a]).filter(Boolean)
  }, [activities]);

  const rows = labels.length ? labels : ['Thinking'];

  return (
    <div
      className="mb-2 rounded-lg border border-gray-600"
      style={{ backgroundColor: 'rgba(255,255,255,0.04)' }}
    >
      <div
        className="flex flex-col px-3 py-2 text-sm"
        style={{ color: '#ff9000' }}
      >
        {rows.map((row, i) => (
          <span key={`${row}-${i}`} className="leading-relaxed">
            {row}
            <span className="inline-flex items-end gap-0.5 ml-0.5" aria-hidden>
              <span className="activity-blink" style={{ animationDelay: '0ms' }}>.</span>
              <span className="activity-blink" style={{ animationDelay: '150ms' }}>.</span>
              <span className="activity-blink" style={{ animationDelay: '300ms' }}>.</span>
            </span>
          </span>
        ))}
      </div>
    </div>
  )
}

export default ActivityStatus;
